import classNames from "classnames";
import React from "react";

import { ButtonBase, ButtonProps } from "./ButtonBase";

type SecondaryButtonColor = "default" | "inverted";

interface SecondaryButtonProps extends ButtonProps {
  /** Changes button background, border, and text colours*/
  buttonColor?: SecondaryButtonColor;
}

export const SecondaryButton: React.FC<SecondaryButtonProps> = ({
  buttonColor = "default",
  children,
  ...props
}) => {
  const buttonClasses = classNames("button-secondary", {
    [`button-secondary--${buttonColor}`]: buttonColor !== "default",
  });

  return (
    <ButtonBase {...props} buttonClasses={buttonClasses}>
      {children}
    </ButtonBase>
  );
};
